const mutations = {
  updateActiveDevicesNum (state, num) {
    state.activeDevicesNum = num
  },
  updateActiveUsersNum (state, num) {
    state.activeUsersNum = num
  },
  updateAdmins (state, admins) {
    state.admins = admins
  },
  updateCompanies (state, companies) {
    state.companies = companies
  },
  updateDevices (state, devices) {
    state.devices = devices
  },
  updateDeviceUsage (state, usage) {
    state.deviceUsage = usage
  },
  updateDeviceUsageNum (state, num) {
    state.deviceUsageNum = num
  },
  updateIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  updateNumDates (state, numDates) {
    state.numDates = numDates
  },
  updatePromotions (state, promotions) {
    state.promotions = promotions
  },
  updateStartDate (state, startDate) {
    state.startDate = startDate
  },
  updateEndDate (state, endDate) {
    state.endDate = endDate
  }
}

export default mutations
